<template>

  <div class="acomodar">

    <button class="btn btn-danger" style="align-self: flex-start; margin-left: 10px;  margin-top: 10px;" @click="$router.push(`/bienvenido`)">
      <i class="bi bi-skip-backward"></i>
    </button>

    <div class="header-titulo">
      <h2> MANUALES INSTRUCTIVOS</h2>
    </div>

    <table class="table" border="1">
      <thead>
      <tr>
        <th>Tema</th>
        <th>Descargas</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in tableData" :key="index">
        <td>{{ item.tema }}</td>
        <td class="text-center">
  <a
    :href="item.urlArchivo"
    download
    target="_blank"
    class="btn btn-light"
  >
    <i class="bi bi-download"></i> Descargar
  </a>
</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name:"ManualInstructivo",
  data() {
    return {
      tableData: [
      { tema: "Vue.js Basics", descargas: ".", urlArchivo: "https://assets.ctfassets.net/zojzzdop0fzx/VU1dEpLKscEoPc2JHDbkZ/cce207f9051d2b53e3782a4f43eb7b5a/A_Complete_Guide_to_VueJS_by_This_Dot_authored_by_Bilal_Haidar.pdf" },
      { tema: "Manual de trabajo en equipo", descargas: ".", urlArchivo: "https://www.facilitadores-alfa.org/wp-content/uploads/2020/11/Manual-de-trabajo-en-equipo.-Robert-S.-Winter.pdf" },
      { tema: "manual instructivo de InfoCultura", descargas: ".", urlArchivo: "https://infocultura2.cultura.pe/infocultura/public/manual/ManualInstructivoInfocultura.pdf" }
      ]
    };
  }
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left:1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}
.title {
  text-align: center;
  width: 100%;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.table {
  width: 80%;
  border-collapse: collapse;
  margin: auto;
}

th, td {
  padding: 10px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}
.header-titulo {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin: 20px;
  text-align: center;
}
</style>

